<template>
  <v-dialog
    v-model="dialog"
    persistent
  >
    <template
      #activator="{on}"
    >
      <v-btn
        color="success"
        outlined
        v-on="on"
      >
        Confirmar usuários
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <form-group>
          <notification-radio-filter
            ref="filter"
          />
        </form-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="#6A6E7B"
          outlined
          @click="dialog = !dialog"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          class="ml-2"
          @click="setUserToReceive()"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import NotificationRadioFilter from 'Modules/contacard/communication/notifications/components/filters/NotificationRadioFilter.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';

export default {
  name: 'NotificationConfirmUser',
  components: {
    NotificationRadioFilter,
    FormGroup,
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    refFilter() {
      const { filter } = this.$refs;
      return filter || {
        setFilter: () => {},
        setAllUsersFilter: () => {},
      };
    },
  },
  methods: {
    setUserToReceive() {
      this.refFilter.setFilter();
      this.dialog = false;
    },
    setAllUsersFilter() {
      this.refFilter.setAllUsersFilter();
    },
  },
};
</script>
